export const loadScript = (src, callback, ctx, ...args) => {
  if (document.querySelector(`[src$="${src}"]`)) {
    callback.call(ctx, ...args);
  } else {
    const scriptElement = document.createElement(`script`);
    scriptElement.src = src;
    scriptElement.async = true;

    document.head.append(scriptElement);
    scriptElement.onload = callback.bind(ctx, ...args);
  }
};
